export default {
  PENDING: 'Pending',
  AUTHORIZED: 'Authorized',
  DENIED: 'Denied',
};
